var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c(_setup.QAgentLicensingSureLc,{attrs:{"agent":_setup.agentSync},on:{"update:agent":function($event){_setup.agentSync=$event}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }